


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { dealService, departmentService, storeService } from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class DepartmentSavePage extends Base {
  public stores: any[];
  public dealRecapBlocks: any = {
    id: '',
    storeId: 0,
    blockName: '',
    sequenceNumber: 0,
    totalTitle: '',
    grossTotalType: '',
  };

  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public storeId: any = 0;
  public paymentTypes: any[];
  public disableSubmitButton: boolean = false;
  public grossTotalType = [
    {
      key: 1,
      value: 'TOTAL FRONT-END GROSS',
    },
    {
      key: 2,
      value: 'TOTAL BACK-END GROSS',
    },
  ];

  public unlinkedDepartments: any;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.dealaccounts.dealrecap',
        params: { storeId: this.storeId },
      });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.submitBlock();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('departments.btnBack'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('departments.btnBack'),
        click: 'backToList',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public async mounted(): Promise<void> {
    this.setFields();
    this.storeId = String(this.$route.params.storeId);
    this.dealRecapBlocks.storeId = this.storeId;
    // this.getDepartments();
    if (this.$route.params.id) {
      const department = await departmentService.getAsync(
        this.$route.params.id,
        this.storeId
      );
      // this.department = department;
      // this.department.storeId = department.storeId.toString();
    }
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.getStores();
  }

  public validateBlock(): Vue & { validate: () => boolean } {
    return this.$refs.blockForm as Vue & { validate: () => boolean };
  }

  public async submitBlock(): Promise<void> {
    if (this.validateBlock().validate()) {
      var validateRes = this.$validator.errors.items.length > 0;
      if (validateRes) {
        this.showAlert(false, 'Please Enter Valid Details');
        return;
      }

      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        if (this.dealRecapBlocks.sequenceNumber == 0) {
          this.showAlert(false, 'Sequence no can not be 0');
          return;
        }

        if (this.$route.params.id) {
          try {
            // await departmentService.updateDepartmentAsync(
            //     this.dealRecapBlocks,
            //     this.storeId,
            // );
            this.showAlert(true, 'Deal Block Updated Successfully');
            this.$router.push({
              name: 'admin.dealaccounts.dealrecap',
              params: { storeId: this.storeId.toString() },
            });
          } catch (e) {
            console.log(e);
          }
        } else {
          try {
            await dealService.saveDealsBlockAsync(
              this.dealRecapBlocks,
              Number(this.storeId)
            );
            this.showAlert(true, 'Deal Block Added Successfully');
            this.$router.push({
              name: 'admin.dealaccounts.dealrecap',
              params: { storeId: this.storeId.toString() },
            });
          } catch (e) {
            console.log(e);
          }
        }
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }
  public setFields(): void {
    this.formFields = [
      {
        key: 'blockName',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 30,
          label: 'Block Name',
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Block Name', v),
            v => this.alphaSpace(v),
          ]
        },
      },
      {
        key: 'sequenceNumber',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
          counter: 7,
          label: 'Block Sequence Number',
          type: 'number',
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Block Sequence Number', v)
          ]
        },
      },
      {
        key: 'totalTitle',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 30,
          label: 'Title For Block Sum',
          required: true,
          disabled: false,
          loading: false,
          rules: [
            v => this.required('Title For Block Sum', v)
          ]
        },
      },
      {
        key: 'grossTotalType',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          counter: 500,
          label: 'Select Options',
          disabled: false,
          items: this.grossTotalType,
          text: 'value',
          value: 'value',
          altag: 'Select Gross Total Type',
          loading: false,
        },
      },
    ];
  }
  public async getStores(): Promise<void> {
    const stores = await storeService.getStoresList();
    this.stores = stores.results;
    this.storeId = String(this.$route.params.storeId);
    this.formFields[0].templateOptions.items = this.stores;
  }
}
